import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Medal, Loader2 } from "lucide-react";
import { SiteLogo } from "@/components/SiteLogo";
import { BrandText } from "@/components/BrandText";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(name.trim(), email.trim().toLowerCase(), password.trim());
      navigate("/app");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center px-6 noise-bg">
      <div className="relative w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <SiteLogo className="w-9 h-9" />
          <div className="flex flex-col leading-tight">
            <BrandText />
          </div>
        </Link>
        <div className="rounded-2xl border border-white/10 bg-[#0F172A] p-8">
          <h1 className="font-display text-3xl">Crea un account</h1>
          <p className="text-muted-foreground text-sm mt-1">Registrati per iscrivere atleti e seguire le gare</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="name">Nome completo</Label>
              <Input id="name" data-testid="register-name-input" value={name} onChange={(e) => setName(e.target.value)} required className="mt-1.5" placeholder="Mario Rossi" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="register-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" placeholder="tu@email.it" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="register-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" placeholder="••••••••" />
            </div>
            {error && <p data-testid="register-error" className="text-sm text-destructive">{error}</p>}
            <Button data-testid="register-submit-btn" type="submit" disabled={loading} className="w-full bg-gold text-[#020617] hover:bg-[#FDE047] font-semibold">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Registrati"}
            </Button>
          </form>
          <p className="text-sm text-muted-foreground mt-6 text-center">
            Hai già un account? <Link to="/login" data-testid="goto-login-link" className="text-gold hover:underline">Accedi</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
